import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

const ErrorPage = () => {
    return (
        <section className="container error-page">
            <Helmet>
                <title>Error | Ailsa Lyn Artist</title>
                <meta name="description" content="This page is displaying as you encountered and error." />
            </Helmet>
            <h2>Error</h2>
            <p>Oops... It appears we've encountered a problem.</p>
            <div className="row">
                <div className="col">
                    <Link to="/">Back to home >></Link>
                </div>
            </div>
        </section>
    );
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/ErrorPage.js